import { FrameName } from "../config";
import AbstractRiverTerrainTileEntity from "./AbstractRiverTerrainTileEntity";

class River11TerrainTileEntity extends AbstractRiverTerrainTileEntity {
	public static readonly frameName = FrameName.RIVER11;
}

export default River11TerrainTileEntity;
